(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["supported-payments"] && !Shopify.designMode) return;
  try {
    spElem = document.querySelector('.sp');
  posClass = '.footer-new-left-content';
  pos = spElem.dataset.position;

  switch (pos) {
    case 'left':
      posClass = '.footer-new-left-content';
      break;
    case 'right':
      posClass = '.footer-new-right-content';
      break;
    case 'center':
      posClass = '.footer-new-middle-container';
      break;
  }

  spElem.remove();
  leftContentElem = document.querySelector(posClass);
  leftContentElem.appendChild(spElem);
  } catch(e) { console.error(e); }
})();

})();
